import React from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table-v6'
import { Loading, Box, Text } from '@piconetworks/ui'
import dayjs from 'dayjs'
import { connect } from 'react-redux'
import Router from 'next/router'

import ModalModule from 'modules/modal'

import ThComponent from 'components/Tables/ReactTable/ThComponent'
import TdComponent from 'components/Tables/ReactTable/TdComponent'
import TrComponent from 'components/Tables/ReactTable/TrComponent'
import EmptyComponent from 'components/Tables/ReactTable/EmptyComponent'
import Value from 'components/Tables/ReactTable/Cells/Value'
import Menu from './Menu'
import { PRODUCT_TYPES_TABLE_DISPLAY } from 'utils/constants/productEdit'

import styles from './Products.module.scss'
import Pagination from 'components/Contacts/List/Pagination'
import ScreenSizeContext from 'utils/contexts/ScreenSize/context'
import { contributionBinSingularSlug } from 'features/ContributionLang'

const MAX_ROW_COUNT = 20

class ProductsTableLayout extends React.PureComponent {
    constructor() {
        super()
        this.state = {
            selectedProduct: null
        }
    }

    handleEdit = (item) => {
        const type = item.type === 'subscription' ? 'individual' : item.type
        Router.push(`/products/edit/${type === 'donation' ? contributionBinSingularSlug() : type}/${item.id}`)
    }

    handleArchive = (item) => {

    }

    handleDelete = (item) => {
        const { dispatch } = this.props
        this.setState({ selectedProduct: item })
        dispatch(ModalModule.creators.openModal({ key: 'deleteProduct' }))
    }

    render() {
        //const { selectedProduct } = this.state
        const { items, loading, noDataText, type } = this.props
        const isBiggerThan = items.length >= MAX_ROW_COUNT
        
        return (
            <ScreenSizeContext.Consumer>
                {({ isLgUp, isMdUp, isSmUp, isXlUp }) => (
                    <>
                        {/* <DeleteModal selectedProduct={selectedProduct} /> */}
                        <ReactTable
                            data={items}
                            getTdProps={(state, rowInfo, column) => { // state is necessary to access rowInfo.original
                                if (rowInfo && column.id !== 'id') {
                                    return {
                                        className: styles.clickable,
                                        handleEdit: () => this.handleEdit(rowInfo.original)
                                    }
                                } else {
                                    return {}
                                }
                            }}
                            columns={[
                                {
                                    Header: 'Name',
                                    accessor: 'title',
                                    width: isXlUp ? 340 : 245,
                                    Cell: ({ value, original }) => (
                                        <Value>
                                            {value || 'N/A'}
                                            {!isLgUp && (
                                                <div className={styles.productDetails}>
                                                    {original.type === 'subscription' ? `${PRODUCT_TYPES_TABLE_DISPLAY[original.type]}\xa0\u2022\xa0` : ''}
                                                    {`Modified ${dayjs(original.updated_at).format('MMM D, YYYY')}`}
                                                </div>
                                            )}
                                        </Value>
                                    )
                                },
                                ...type === 'subscription' ? [
                                    {
                                        Header: 'Type',
                                        accessor: 'type',
                                        show: isLgUp,
                                        width: isXlUp ? 200 : 150,
                                        Cell: ({ value }) => <Value>{PRODUCT_TYPES_TABLE_DISPLAY[value]}</Value>
                                    }
                                ] : [],
                                {
                                    Header: 'Created',
                                    accessor: 'created_at',
                                    show: isLgUp,
                                    width: isXlUp ? 200 : 150,
                                    Cell: ({ value, original }) =>
                                        <Box.Flexbox.Container flexDirection="column">
                                            <Value>{dayjs(value).format('MMM D, YYYY')}</Value>
                                            {original.created_by && <Text.P className={styles.text}>{original.created_by}</Text.P>}
                                        </Box.Flexbox.Container>
                                },
                                {
                                    Header: 'Last Updated',
                                    accessor: 'updated_at',
                                    show: isLgUp,
                                    width: isXlUp ? 200 : 150,
                                    Cell: ({ value, original }) =>
                                        <Box.Flexbox.Container flexDirection="column">
                                            <Value>{dayjs(value).format('MMM D, YYYY')}</Value>
                                            {original.updated_by && <Text.P className={styles.text}>{original.updated_by}</Text.P>}
                                        </Box.Flexbox.Container>
                                },
                                // {
                                //     Header: 'Conversion Rate',
                                //     accessor: 'conversation_rate',
                                //     width: 125,
                                //     Cell: ({ value, original }) =>
                                //         <Box.Flexbox.Container flexDirection="column">
                                //             <Value>{(value)}%</Value>
                                //             {original.signups && <Text.P className={styles.text}>{original.signups}</Text.P>}
                                //         </Box.Flexbox.Container>
                                // },
                                {
                                    accessor: 'id',
                                    width: 38,
                                    Cell: ({ original }) =>
                                        <Menu
                                            item={original}
                                            handleEdit={this.handleEdit}
                                            handleDelete={this.handleDelete}
                                            handleArchive={this.handleArchive}
                                        />
                                }
                            ]}
                            loading={loading}
                            TheadComponent={props => <ThComponent {...props} className={styles.th} />}
                            ThComponent={props => <ThComponent {...props} className={styles.th} />}
                            TrComponent={props => <TrComponent {...props} />}
                            TdComponent={TdComponent}
                            LoadingComponent={() => loading && <Loading />}
                            minRows={1}
                            showPagination={isBiggerThan}
                            defaultPageSize={20}
                            resizable={false}
                            showPageSizeOptions={false}
                            dontShowRowCount={isBiggerThan}
                            dontShowOptions={isBiggerThan}
                            sortable={false}
                            PaginationComponent={Pagination}
                            className={styles.table}
                            noDataText={noDataText}
                            NoDataComponent={EmptyComponent}
                        />
                    </>
                )}
            </ScreenSizeContext.Consumer>
        )
    }
}

ProductsTableLayout.propTypes = {
    dispatch: PropTypes.func,
    items: PropTypes.array,
    loading: PropTypes.bool,
    noDataText: PropTypes.string,
    type: PropTypes.string,
}

export default connect()(ProductsTableLayout)
